/* global axios */
import ApiClient from '../ApiClient';

class AiDraftsApi extends ApiClient {
  constructor() {
    super('conversations', { accountScoped: true });
  }

  base(conversationId) {
    return `${this.url}/${conversationId}/ai_drafts`;
  }

  getLatest(conversationId) {
    return axios.get(`${this.base(conversationId)}/latest`);
  }

  accept(conversationId, draftId) {
    return axios.post(`${this.base(conversationId)}/${draftId}/accept`);
  }

  editAndSend(conversationId, draftId, finalContent) {
    return axios.post(`${this.base(conversationId)}/${draftId}/edit_and_send`, {
      final_content: finalContent,
    });
  }

  reject(conversationId, draftId) {
    return axios.post(`${this.base(conversationId)}/${draftId}/reject`);
  }

  regenerate(conversationId) {
    return axios.post(`${this.base(conversationId)}/regenerate`);
  }

  markOutcome(
    conversationId,
    draftId,
    { actionType, finalContent, sentMessageId }
  ) {
    return axios.post(`${this.base(conversationId)}/${draftId}/mark_outcome`, {
      action_type: actionType,
      final_content: finalContent,
      sent_message_id: sentMessageId,
    });
  }

  reportFeedback(conversationId, draftId, { rating, categories, comment }) {
    return axios.post(
      `${this.base(conversationId)}/${draftId}/report_feedback`,
      { rating, categories, comment }
    );
  }

  classifierAnalysis(conversationId, draftId) {
    return axios.get(
      `${this.base(conversationId)}/${draftId}/classifier_analysis`
    );
  }
}

export default new AiDraftsApi();
